module.exports = __webpack_public_path__ + "img/txtImg.12d677c9.png";